import {
    spaceTypes,
    CreateSpacePayload,
    UpdateSpacePayload,
    SpaceFilters,
    AddSpaceMembersPayload,
    AddSpaceGuestsPayload,
    SpaceGuestAcceptPayload,
    SpaceGuestLoginPayload,
    SpaceGuestTokenVerifyPayload,
    CreateSpaceTaskPayload,
    UpdateSpaceTaskPayload,
    SpaceTaskFilters,
} from "redux/Ldb/types/spaceTypes";
import { spaceService } from "services/Ldb/spaceService";
import { Dispatch } from "redux";
import { saveToStorage } from "helpers";
import toast from "react-hot-toast";
import CustomToast from "components/common/CustomToast";

export const spaceActions = {
    fetchSingleSpace,
    fetchSpaces,
    createSpace,
    updateSpace,
    deleteSpace,
    pinSpace,
    unpinSpace,
    archiveSpace,
    unarchiveSpace,
    addSpaceMembers,
    removeSpaceMember,
    addSpaceGuests,
    removeSpaceGuest,
    spaceGuestAccept,
    spaceGuestLogin,
    spaceGuestTokenVerify,
    getSpaceGuestInvitePreview,
    getSpaceGuestBrands,
    leaveSpace,
    // Space Message Actions - temporarily disabled
    // fetchSpaceMessages,
    // sendSpaceMessage,
    // pinSpaceMessage,
    // unpinSpaceMessage,
    // editSpaceMessage,
    // deleteSpaceMessage,
    // Space Message Actions
    fetchSpaceMessages,
    sendSpaceMessage,
    pinSpaceMessage,
    unpinSpaceMessage,
    editSpaceMessage,
    deleteSpaceMessage,
    resetFetchSingleSpace,
    resetFetchSpaces,
    resetCreateSpace,
    resetUpdateSpace,
    resetDeleteSpace,
    resetPinSpace,
    resetUnpinSpace,
    resetArchiveSpace,
    resetUnarchiveSpace,
    resetAddSpaceMembers,
    resetRemoveSpaceMember,
    resetAddSpaceGuests,
    resetRemoveSpaceGuest,
    resetSpaceGuestAccept,
    resetSpaceGuestLogin,
    resetSpaceGuestTokenVerify,
    resetGetSpaceGuestInvitePreview,
    resetGetSpaceGuestBrands,
    createSpaceFile,
    getSpaceFiles,
    getSingleSpaceFile,
    deleteSpaceFile,
    resetCreateSpaceFile,
    resetGetSpaceFiles,
    resetGetSingleSpaceFile,
    resetDeleteSpaceFile,
    createSpaceNote,
    updateSpaceNote,
    getSpaceNotes,
    getSpaceSingleNote,
    deleteSpaceNote,
    resetCreateSpaceNote,
    resetUpdateSpaceNote,
    resetGetSpaceNotes,
    resetGetSpaceSingleNote,
    resetDeleteSpaceNote,
    pinSpaceNote,
    unpinSpaceNote,
    resetPinSpaceNote,
    resetUnpinSpaceNote,
    resetLeaveSpace,
    // Space Message Reset Actions - temporarily disabled
    // resetFetchSpaceMessages,
    // resetSendSpaceMessage,
    // resetPinSpaceMessage,
    // resetUnpinSpaceMessage,
    // resetEditSpaceMessage,
    // resetDeleteSpaceMessage,
    // Space Message Reset Actions
    resetFetchSpaceMessages,
    resetSendSpaceMessage,
    resetPinSpaceMessage,
    resetUnpinSpaceMessage,
    resetEditSpaceMessage,
    resetDeleteSpaceMessage,
    // Space Task Actions
    fetchSpaceTasks,
    fetchSingleSpaceTask,
    createSpaceTask,
    updateSpaceTask,
    deleteSpaceTask,
    resetFetchSpaceTasks,
    resetFetchSingleSpaceTask,
    resetCreateSpaceTask,
    resetUpdateSpaceTask,
    resetDeleteSpaceTask,
    fetchSpaceTasksRuns,
    resetFetchSpaceTasksRuns,
    fetchSpaceUnreadCount,
    resetFetchSpaceUnreadCount,
    request,
    success,
    failure,
};

function fetchSingleSpace(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SINGLE_SPACE_REQUEST));
        try {
            const response = await spaceService.getSingleSpace(id);
            dispatch(success(spaceTypes.FETCH_SINGLE_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.FETCH_SINGLE_SPACE_FAILURE, error));
        }
    };
}

function fetchSpaces(filters?: SpaceFilters) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SPACES_REQUEST));
        try {
            const response = await spaceService.getSpaces(filters);
            dispatch(success(spaceTypes.FETCH_SPACES_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.FETCH_SPACES_FAILURE, error));
        }
    };
}

function createSpace(data: CreateSpacePayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.CREATE_SPACE_REQUEST));
        try {
            const response = await spaceService.createSpace(data);
            dispatch(success(spaceTypes.CREATE_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.CREATE_SPACE_FAILURE, error));
        }
    };
}

function updateSpace(spaceId: string, data: UpdateSpacePayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.UPDATE_SPACE_REQUEST));
        try {
            const response = await spaceService.updateSpace(spaceId, data);
            dispatch(success(spaceTypes.UPDATE_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.UPDATE_SPACE_FAILURE, error));
        }
    };
}

function deleteSpace(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.DELETE_SPACE_REQUEST));
        try {
            const response = await spaceService.deleteSpace(id);
            dispatch(success(spaceTypes.DELETE_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.DELETE_SPACE_FAILURE, error));
        }
    };
}

function pinSpace(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.PIN_SPACE_REQUEST));
        try {
            const response = await spaceService.pinSpace(id);
            dispatch(success(spaceTypes.PIN_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.PIN_SPACE_FAILURE, error));
        }
    };
}

function unpinSpace(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.UNPIN_SPACE_REQUEST));
        try {
            const response = await spaceService.unpinSpace(id);
            dispatch(success(spaceTypes.UNPIN_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.UNPIN_SPACE_FAILURE, error));
        }
    };
}

function archiveSpace(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.ARCHIVE_SPACE_REQUEST));
        try {
            const response = await spaceService.archiveSpace(id);
            dispatch(success(spaceTypes.ARCHIVE_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.ARCHIVE_SPACE_FAILURE, error));
        }
    };
}

function unarchiveSpace(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.UNARCHIVE_SPACE_REQUEST));
        try {
            const response = await spaceService.unarchiveSpace(id);
            dispatch(success(spaceTypes.UNARCHIVE_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.UNARCHIVE_SPACE_FAILURE, error));
        }
    };
}

function addSpaceMembers(spaceId: string, data: AddSpaceMembersPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.ADD_SPACE_MEMBERS_REQUEST));
        try {
            const response = await spaceService.addSpaceMembers(spaceId, data);
            dispatch(success(spaceTypes.ADD_SPACE_MEMBERS_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.ADD_SPACE_MEMBERS_FAILURE, error));
        }
    };
}

function removeSpaceMember(spaceId: string, memberId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.REMOVE_SPACE_MEMBER_REQUEST));
        try {
            const response = await spaceService.removeSpaceMember(spaceId, memberId);
            dispatch(success(spaceTypes.REMOVE_SPACE_MEMBER_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.REMOVE_SPACE_MEMBER_FAILURE, error));
        }
    };
}

function addSpaceGuests(spaceId: string, data: AddSpaceGuestsPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.ADD_SPACE_GUESTS_REQUEST));
        try {
            const response = await spaceService.addSpaceGuests(spaceId, data);
            dispatch(success(spaceTypes.ADD_SPACE_GUESTS_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.ADD_SPACE_GUESTS_FAILURE, error));
        }
    };
}

function removeSpaceGuest(spaceId: string, guestId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.REMOVE_SPACE_GUEST_REQUEST));
        try {
            const response = await spaceService.removeSpaceGuest(spaceId, guestId);
            dispatch(success(spaceTypes.REMOVE_SPACE_GUEST_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.REMOVE_SPACE_GUEST_FAILURE, error));
        }
    };
}

function spaceGuestAccept(data: SpaceGuestAcceptPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.SPACE_GUEST_ACCEPT_REQUEST));
        try {
            const response = await spaceService.spaceGuestAccept(data);
            saveToStorage("ally-user", response?.data, true);
            dispatch(success(spaceTypes.SPACE_GUEST_ACCEPT_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.SPACE_GUEST_ACCEPT_FAILURE, error));
        }
    };
}

function spaceGuestLogin(data: SpaceGuestLoginPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.SPACE_GUEST_LOGIN_REQUEST));
        try {
            const response = await spaceService.spaceGuestLogin(data);
            dispatch(success(spaceTypes.SPACE_GUEST_LOGIN_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.SPACE_GUEST_LOGIN_FAILURE, error));
        }
    };
}

function spaceGuestTokenVerify(data: SpaceGuestTokenVerifyPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.SPACE_GUEST_TOKEN_VERIFY_REQUEST));
        try {
            const response = await spaceService.spaceGuestTokenVerify(data);
            saveToStorage("ally-user", response?.data, true);
            dispatch(success(spaceTypes.SPACE_GUEST_TOKEN_VERIFY_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.SPACE_GUEST_TOKEN_VERIFY_FAILURE, error));
        }
    };
}

function getSpaceGuestInvitePreview(token: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.GET_SPACE_GUEST_INVITE_PREVIEW_REQUEST));
        try {
            const response = await spaceService.getSpaceGuestInvitePreview(token);
            dispatch(success(spaceTypes.GET_SPACE_GUEST_INVITE_PREVIEW_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.GET_SPACE_GUEST_INVITE_PREVIEW_FAILURE, error));
        }
    };
}

function getSpaceGuestBrands() {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.GET_SPACE_GUEST_BRANDS_REQUEST));
        try {
            const response = await spaceService.getSpaceGuestBrands();
            dispatch(success(spaceTypes.GET_SPACE_GUEST_BRANDS_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.GET_SPACE_GUEST_BRANDS_FAILURE, error));
        }
    };
}

function createSpaceFile(id: string, data: Record<string, any>) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.CREATE_SPACE_FILE_REQUEST));
        try {
            const response = await spaceService.createSpaceFile(id, data);
            dispatch(success(spaceTypes.CREATE_SPACE_FILE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.CREATE_SPACE_FILE_FAILURE, error));
        }
    };
}

function leaveSpace(spaceId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.LEAVE_SPACE_REQUEST));
        try {
            const response = await spaceService.leaveSpace(spaceId);
            dispatch(success(spaceTypes.LEAVE_SPACE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.LEAVE_SPACE_FAILURE, error));
        }
    };
}

function getSpaceFiles(
    id: string,
    page: number,
    limit: number,
    search?: string,
    fileTypes?: string,
    memberId?: string
) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.GET_SPACE_FILES_REQUEST));
        try {
            const response = await spaceService.getSpaceFiles(
                id,
                page,
                limit,
                search,
                fileTypes,
                memberId
            );
            dispatch(success(spaceTypes.GET_SPACE_FILES_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.GET_SPACE_FILES_FAILURE, error));
        }
    };
}

function getSingleSpaceFile(id: string, fileId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.GET_SINGLE_SPACE_FILE_REQUEST));
        try {
            const response = await spaceService.getSingleSpaceFile(id, fileId);
            dispatch(success(spaceTypes.GET_SINGLE_SPACE_FILE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.GET_SINGLE_SPACE_FILE_FAILURE, error));
        }
    };
}

function deleteSpaceFile(id: string, fileId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.DELETE_SPACE_FILE_REQUEST));
        try {
            const response = await spaceService.deleteSpaceFile(id, fileId);
            dispatch(success(spaceTypes.DELETE_SPACE_FILE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.DELETE_SPACE_FILE_FAILURE, error));
        }
    };
}
function createSpaceNote(id: string, data: Record<string, any>) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.CREATE_SPACE_NOTE_REQUEST));
        try {
            const response = await spaceService.createSpaceNote(id, data);
            dispatch(success(spaceTypes.CREATE_SPACE_NOTE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.CREATE_SPACE_NOTE_FAILURE, error));
        }
    };
}
function updateSpaceNote(id: string, noteId: string, data: Record<string, any>) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.UPDATE_SPACE_NOTE_REQUEST));
        try {
            const response = await spaceService.updateSpaceNote(id, noteId, data);
            dispatch(success(spaceTypes.UPDATE_SPACE_NOTE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.UPDATE_SPACE_NOTE_FAILURE, error));
        }
    };
}

function getSpaceNotes(
    id: string,
    page: number,
    limit: number,
    search?: string,
    createdBy?: string,
    sortBy?: string
) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SPACE_NOTES_REQUEST));
        try {
            const response = await spaceService.getSpaceNotes(
                id,
                page,
                limit,
                search,
                createdBy,
                sortBy
            );
            dispatch(success(spaceTypes.FETCH_SPACE_NOTES_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.FETCH_SPACE_NOTES_FAILURE, error));
        }
    };
}
function getSpaceSingleNote(id: string, noteId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SINGLE_SPACE_NOTE_REQUEST));
        try {
            const response = await spaceService.getSpaceSingleNote(id, noteId);
            dispatch(success(spaceTypes.FETCH_SINGLE_SPACE_NOTE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.FETCH_SINGLE_SPACE_NOTE_FAILURE, error));
        }
    };
}

function deleteSpaceNote(id: string, noteId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.DELETE_SPACE_NOTE_REQUEST));
        try {
            const response = await spaceService.deleteSpaceNote(id, noteId);
            dispatch(success(spaceTypes.DELETE_SPACE_NOTE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.DELETE_SPACE_NOTE_FAILURE, error));
        }
    };
}

function pinSpaceNote(id: string, noteId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.PIN_SPACE_NOTE_REQUEST));
        try {
            const response = await spaceService.pinSpaceNote(id, noteId);
            dispatch(success(spaceTypes.PIN_SPACE_NOTE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.PIN_SPACE_NOTE_FAILURE, error));
        }
    };
}

function unpinSpaceNote(id: string, noteId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.UNPIN_SPACE_NOTE_REQUEST));
        try {
            const response = await spaceService.unpinSpaceNote(id, noteId);
            dispatch(success(spaceTypes.UNPIN_SPACE_NOTE_SUCCESS, response));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
            dispatch(failure(spaceTypes.UNPIN_SPACE_NOTE_FAILURE, error));
        }
    };
}

function resetPinSpaceNote() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.PIN_SPACE_NOTE_SUCCESS, null));
    };
}
function resetUnpinSpaceNote() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.UNPIN_SPACE_NOTE_SUCCESS, null));
    };
}

function resetCreateSpaceNote() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.CREATE_SPACE_NOTE_SUCCESS, null));
    };
}

function resetUpdateSpaceNote() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.UPDATE_SPACE_NOTE_SUCCESS, null));
    };
}
function resetGetSpaceNotes() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.FETCH_SPACE_NOTES_SUCCESS, null));
    };
}
function resetGetSpaceSingleNote() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.FETCH_SINGLE_SPACE_NOTE_SUCCESS, null));
    };
}
function resetDeleteSpaceNote() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.DELETE_SPACE_NOTE_SUCCESS, null));
    };
}

function resetCreateSpaceFile() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.CREATE_SPACE_FILE_SUCCESS, null));
    };
}
function resetGetSpaceFiles() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.GET_SPACE_FILES_SUCCESS, null));
    };
}
function resetGetSingleSpaceFile() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.GET_SINGLE_SPACE_FILE_SUCCESS, null));
    };
}
function resetDeleteSpaceFile() {
    return (dispatch: Dispatch) => {
        dispatch(success(spaceTypes.DELETE_SPACE_FILE_SUCCESS, null));
    };
}

// Reset actions
function resetFetchSingleSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_FETCH_SINGLE_SPACE });
    };
}

function resetFetchSpaces() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_FETCH_SPACES });
    };
}

function resetCreateSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_CREATE_SPACE });
    };
}

function resetUpdateSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_UPDATE_SPACE });
    };
}

function resetDeleteSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_DELETE_SPACE });
    };
}

function resetPinSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_PIN_SPACE });
    };
}

function resetUnpinSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_UNPIN_SPACE });
    };
}

function resetArchiveSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_ARCHIVE_SPACE });
    };
}

function resetUnarchiveSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_UNARCHIVE_SPACE });
    };
}

function resetAddSpaceMembers() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_ADD_SPACE_MEMBERS });
    };
}

function resetRemoveSpaceMember() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_REMOVE_SPACE_MEMBER });
    };
}

function resetAddSpaceGuests() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_ADD_SPACE_GUESTS });
    };
}

function resetRemoveSpaceGuest() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_REMOVE_SPACE_GUEST });
    };
}

function resetSpaceGuestAccept() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_SPACE_GUEST_ACCEPT });
    };
}

function resetSpaceGuestLogin() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_SPACE_GUEST_LOGIN });
    };
}

function resetSpaceGuestTokenVerify() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_SPACE_GUEST_TOKEN_VERIFY });
    };
}

function resetGetSpaceGuestInvitePreview() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_GET_SPACE_GUEST_INVITE_PREVIEW });
    };
}

function resetGetSpaceGuestBrands() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_GET_SPACE_GUEST_BRANDS });
    };
}

function resetLeaveSpace() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_LEAVE_SPACE });
    };
}

// Space Message Actions - temporarily disabled
/*
function fetchSpaceMessages(payload: GetSpaceMessagesPayload) {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(request(spaceTypes.FETCH_SPACE_MESSAGES_REQUEST));
            const response = await spaceMessageService.getSpaceMessages(payload);
            dispatch(success(spaceTypes.FETCH_SPACE_MESSAGES_SUCCESS, response));
            return response;
        } catch (error) {
            dispatch(failure(spaceTypes.FETCH_SPACE_MESSAGES_FAILURE, error));
            throw error;
        }
    };
}

function pinSpaceMessage(payload: PinSpaceMessagePayload) {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(request(spaceTypes.PIN_SPACE_MESSAGE_REQUEST));
            const response = await spaceMessageService.pinSpaceMessage(payload);
            dispatch(success(spaceTypes.PIN_SPACE_MESSAGE_SUCCESS, response));
            return response;
        } catch (error) {
            dispatch(failure(spaceTypes.PIN_SPACE_MESSAGE_FAILURE, error));
            throw error;
        }
    };
}

function unpinSpaceMessage(payload: PinSpaceMessagePayload) {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(request(spaceTypes.UNPIN_SPACE_MESSAGE_REQUEST));
            const response = await spaceMessageService.unpinSpaceMessage(payload);
            dispatch(success(spaceTypes.UNPIN_SPACE_MESSAGE_SUCCESS, response));
            return response;
        } catch (error) {
            dispatch(failure(spaceTypes.UNPIN_SPACE_MESSAGE_FAILURE, error));
            throw error;
        }
    };
}

// Space Message Reset Actions
function resetFetchSpaceMessages() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_FETCH_SPACE_MESSAGES });
    };
}

function resetSendSpaceMessage() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_SEND_SPACE_MESSAGE });
    };
}

function resetPinSpaceMessage() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_PIN_SPACE_MESSAGE });
    };
}

function resetUnpinSpaceMessage() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_UNPIN_SPACE_MESSAGE });
    };
}

function resetEditSpaceMessage() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_EDIT_SPACE_MESSAGE });
    };
}

function resetDeleteSpaceMessage() {
    return (dispatch: Dispatch) => {
        dispatch({ type: spaceTypes.RESET_DELETE_SPACE_MESSAGE });
    };
}
*/

// Space Message Actions
function fetchSpaceMessages(spaceId: string, options: { page?: number; limit?: number } = {}) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SPACE_MESSAGES_REQUEST));
        try {
            // Use spaceService with pagination parameters
            const response = await spaceService.getSpaceMessages(spaceId, {
                page: options.page || 1,
                limit: options.limit || 50, // Match the hook's default limit
            });
            dispatch(success(spaceTypes.FETCH_SPACE_MESSAGES_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.FETCH_SPACE_MESSAGES_FAILURE, error));
        }
    };
}

function sendSpaceMessage(spaceId: string, data: any) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.SEND_SPACE_MESSAGE_REQUEST));
        try {
            const response = await spaceService.sendSpaceMessage(spaceId, data);
            dispatch(success(spaceTypes.SEND_SPACE_MESSAGE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.SEND_SPACE_MESSAGE_FAILURE, error));
        }
    };
}

function pinSpaceMessage(spaceId: string, messageId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.PIN_SPACE_MESSAGE_REQUEST));
        try {
            const response = await spaceService.pinSpaceMessage(spaceId, messageId);
            dispatch(success(spaceTypes.PIN_SPACE_MESSAGE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.PIN_SPACE_MESSAGE_FAILURE, error));
        }
    };
}

function unpinSpaceMessage(spaceId: string, messageId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.UNPIN_SPACE_MESSAGE_REQUEST));
        try {
            const response = await spaceService.unpinSpaceMessage(spaceId, messageId);
            dispatch(success(spaceTypes.UNPIN_SPACE_MESSAGE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.UNPIN_SPACE_MESSAGE_FAILURE, error));
        }
    };
}

function editSpaceMessage(spaceId: string, messageId: string, data: any) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.EDIT_SPACE_MESSAGE_REQUEST));
        try {
            const response = await spaceService.editSpaceMessage(spaceId, messageId, data);
            dispatch(success(spaceTypes.EDIT_SPACE_MESSAGE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.EDIT_SPACE_MESSAGE_FAILURE, error));
        }
    };
}

function deleteSpaceMessage(spaceId: string, messageId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.DELETE_SPACE_MESSAGE_REQUEST));
        try {
            const response = await spaceService.deleteSpaceMessage(spaceId, messageId);
            dispatch(success(spaceTypes.DELETE_SPACE_MESSAGE_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.DELETE_SPACE_MESSAGE_FAILURE, error));
        }
    };
}

// Space Message Reset Actions
function resetFetchSpaceMessages() {
    return { type: spaceTypes.RESET_FETCH_SPACE_MESSAGES };
}

function resetSendSpaceMessage() {
    return { type: spaceTypes.RESET_SEND_SPACE_MESSAGE };
}

function resetPinSpaceMessage() {
    return { type: spaceTypes.RESET_PIN_SPACE_MESSAGE };
}

function resetUnpinSpaceMessage() {
    return { type: spaceTypes.RESET_UNPIN_SPACE_MESSAGE };
}

function resetEditSpaceMessage() {
    return { type: spaceTypes.RESET_EDIT_SPACE_MESSAGE };
}

function resetDeleteSpaceMessage() {
    return { type: spaceTypes.RESET_DELETE_SPACE_MESSAGE };
}

// Space Task Actions
function fetchSpaceTasks(spaceId: string, filters?: SpaceTaskFilters) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SPACE_TASKS_REQUEST));
        try {
            const response = await spaceService.getSpaceTasks(spaceId, filters);
            dispatch(success(spaceTypes.FETCH_SPACE_TASKS_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.FETCH_SPACE_TASKS_FAILURE, error));
        }
    };
}

function fetchSingleSpaceTask(spaceId: string, taskId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SINGLE_SPACE_TASK_REQUEST));
        try {
            const response = await spaceService.getSingleSpaceTask(spaceId, taskId);
            dispatch(success(spaceTypes.FETCH_SINGLE_SPACE_TASK_SUCCESS, response?.data));
        } catch (error) {
            dispatch(failure(spaceTypes.FETCH_SINGLE_SPACE_TASK_FAILURE, error));
        }
    };
}

function createSpaceTask(spaceId: string, data: CreateSpaceTaskPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.CREATE_SPACE_TASK_REQUEST));
        try {
            const response = await spaceService.createSpaceTask(spaceId, data);
            dispatch(success(spaceTypes.CREATE_SPACE_TASK_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.CREATE_SPACE_TASK_FAILURE, error));
            toast.error("Failed to create task", {
                duration: 3000,
                icon: "❌",
            });
        }
    };
}

function updateSpaceTask(spaceId: string, taskId: string, data: UpdateSpaceTaskPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.UPDATE_SPACE_TASK_REQUEST));
        try {
            const response = await spaceService.updateSpaceTask(spaceId, taskId, data);
            dispatch(success(spaceTypes.UPDATE_SPACE_TASK_SUCCESS, response));
        } catch (error) {
            dispatch(failure(spaceTypes.UPDATE_SPACE_TASK_FAILURE, error));
            toast.error("Failed to update task", {
                duration: 3000,
                icon: "❌",
            });
        }
    };
}

function deleteSpaceTask(spaceId: string, taskId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.DELETE_SPACE_TASK_REQUEST));
        try {
            const response = await spaceService.deleteSpaceTask(spaceId, taskId);
            dispatch(success(spaceTypes.DELETE_SPACE_TASK_SUCCESS, response));
            toast.success("Task deleted successfully!", {
                duration: 3000,
                icon: "✅",
            });
        } catch (error) {
            dispatch(failure(spaceTypes.DELETE_SPACE_TASK_FAILURE, error));
            toast.error("Failed to delete task", {
                duration: 3000,
                icon: "❌",
            });
        }
    };
}

function fetchSpaceTasksRuns(
    spaceId?: string,
    page?: number,
    limit?: number,
    parentTaskId?: string,
    status?: string,
    taskType?: string,
    search?: string
) {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SPACE_TASKS_RUNS_REQUEST));
        try {
            const response = await spaceService.getSpaceTasksRuns(
                spaceId,
                page,
                limit,
                parentTaskId,
                status,
                taskType,
                search
            );
            dispatch(success(spaceTypes.FETCH_SPACE_TASKS_RUNS_SUCCESS, response?.data));
        } catch (error) {
            dispatch(failure(spaceTypes.FETCH_SPACE_TASKS_RUNS_FAILURE, error));
        }
    };
}

function fetchSpaceUnreadCount() {
    return async (dispatch: Dispatch) => {
        dispatch(request(spaceTypes.FETCH_SPACE_UNREAD_COUNT_REQUEST));
        try {
            const response = await spaceService.fetchSpaceUnreadCount();
            dispatch(success(spaceTypes.FETCH_SPACE_UNREAD_COUNT_SUCCESS, response?.data));
        } catch (error) {
            dispatch(failure(spaceTypes.FETCH_SPACE_UNREAD_COUNT_FAILURE, error));
        }
    };
}

// Space Task Reset Actions

function resetFetchSpaceTasksRuns() {
    return { type: spaceTypes.FETCH_SPACE_TASKS_RUNS_SUCCESS, payload: null };
}

function resetFetchSpaceUnreadCount() {
    return { type: spaceTypes.FETCH_SPACE_UNREAD_COUNT_SUCCESS, payload: null };
}

function resetFetchSpaceTasks() {
    return { type: spaceTypes.RESET_FETCH_SPACE_TASKS };
}

function resetFetchSingleSpaceTask() {
    return { type: spaceTypes.RESET_FETCH_SINGLE_SPACE_TASK };
}

function resetCreateSpaceTask() {
    return { type: spaceTypes.RESET_CREATE_SPACE_TASK };
}

function resetUpdateSpaceTask() {
    return { type: spaceTypes.RESET_UPDATE_SPACE_TASK };
}

function resetDeleteSpaceTask() {
    return { type: spaceTypes.RESET_DELETE_SPACE_TASK };
}

function request(type: string) {
    return { type };
}

function success(type: string, data?: any) {
    return { type, payload: data };
}

function failure(type: string, error?: any) {
    return { type, payload: error };
}
